export default "__VITE_ASSET__CdRQJ9zn__"